import React from 'react';
import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';

import { PdfViewer } from '../../../components/PdfViewer';

interface PdfPreviewModalProps {
  open: boolean;
  onClose: () => void;
  pdfData: {
    pdf_data: string;
    title?: string;
  } | null;
  documentMetadata?: {
    patientId?: string;
    noteId?: string;
  };
}

export const PdfPreviewModal: React.FC<PdfPreviewModalProps> = ({
  open,
  onClose,
  pdfData,
  documentMetadata,
}) => {
  if (!pdfData) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          height: '90vh',
          maxHeight: '90vh',
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">PDF Preview</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: 2, overflow: 'hidden' }}>
        <PdfViewer
          base64Data={pdfData.pdf_data}
          filename={pdfData.title || 'Document'}
          height="100%"
          eventMetadata={{
            documentType: 'generated_document',
            patientId: documentMetadata?.patientId,
            noteId: documentMetadata?.noteId,
          }}
        />
      </DialogContent>
    </Dialog>
  );
};
